import {
  startOfDay,
  endOfDay,
  subDays,
  subMonths,
  startOfMonth,
  endOfMonth,
  format,
} from 'date-fns';

export const formatDate = date => format(date, 'yyyy-MM-dd HH:mm:ss');

export const getDateRange = (days, includeCurrent = false) => ({
  start: formatDate(
    startOfDay(subDays(new Date(), includeCurrent ? days - 1 : days)),
  ),
  end: includeCurrent
    ? formatDate(endOfDay(new Date()))
    : formatDate(endOfDay(subDays(new Date(), 1))),
});

export const dateRanges = {
  today: () => ({
    start: formatDate(startOfDay(new Date())),
    end: formatDate(endOfDay(new Date())),
  }),
  yesterday: () => ({
    start: formatDate(startOfDay(subDays(new Date(), 1))),
    end: formatDate(endOfDay(subDays(new Date(), 1))),
  }),
  seven_days: (includeCurrent = true) =>
    includeCurrent
      ? {
          start: formatDate(startOfDay(subDays(new Date(), 6))),
          end: formatDate(endOfDay(new Date())),
        }
      : {
          start: formatDate(startOfDay(subDays(new Date(), 7))),
          end: formatDate(endOfDay(subDays(new Date(), 1))),
        },
  this_month: () => ({
    start: formatDate(startOfMonth(new Date())),
    end: formatDate(endOfDay(new Date())),
  }),
  last_month: (includeCurrent = true) => ({
    start: formatDate(startOfMonth(subMonths(new Date(), 1))),
    end: includeCurrent
      ? formatDate(endOfDay(new Date()))
      : formatDate(endOfMonth(subMonths(new Date(), 1))),
  }),
  last_three_month: (includeCurrent = true) => ({
    start: formatDate(startOfMonth(subMonths(new Date(), 3))),
    end: includeCurrent
      ? formatDate(endOfDay(new Date()))
      : formatDate(endOfMonth(subMonths(new Date(), 1))),
  }),
  last_six_month: (includeCurrent = true) => ({
    start: formatDate(startOfMonth(subMonths(new Date(), 6))),
    end: includeCurrent
      ? formatDate(endOfDay(new Date()))
      : formatDate(endOfMonth(subMonths(new Date(), 1))),
  }),
};
